import { getWithExpiry, setWithExpiry } from "./storageUtils";
import { fetchCustomerStatus, CustomerStatus } from "../services/customerStatusService";

const STORAGE_KEY = "customer_status";
const TTL = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

const FALLBACK_CUSTOMER_STATUS: CustomerStatus = {
  is_acko_customer: false,
  is_active_policy_holder: false,
  active_policies: "",
  expired_policies: "",
  acko_user: "No",
  old_vehicle_numbers: "",
  car_details: "",
  car_registration: "",
};

/**
 * Get customer status information with caching
 * This function determines if the user is an existing customer and their type
 */
export async function getCustomerStatus(): Promise<CustomerStatus> {
  if (typeof window === "undefined") {
    console.warn("Attempted to access customer status on server-side.");
    return FALLBACK_CUSTOMER_STATUS;
  }

  try {
    const cached = getWithExpiry<CustomerStatus>(STORAGE_KEY);
    if (cached) {
      console.info("Using cached customer status:", cached);
      return cached;
    }

    console.info("No cached customer status — calling API.");
    const data = await fetchCustomerStatus();
    if (data) {
      setWithExpiry(STORAGE_KEY, data, TTL);
      return data;
    }
    return FALLBACK_CUSTOMER_STATUS;
  } catch (error) {
    console.error("Failed to get customer status, using fallback.", error);
    return FALLBACK_CUSTOMER_STATUS;
  }
} 